import React from 'react';
import { Avatar } from '../../core/Avatar/Avatar';

type Variant = 'user' | 'other_user' | 'organization';

export type PartyAvatarProps = {
  /**
   * Name of the person or organization (party) the Avatar belongs to
   */
  name: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: Variant;
  className?: string;
};

function variantColor(variant: Variant) {
  switch (variant) {
    case 'user':
      return 'teal';
    case 'other_user':
      return 'navy';
    case 'organization':
      return 'grey';
    default:
      throw new Error(`Unsupported variant: ${variant}`);
  }
}

const PartyAvatar = (
  { name, className, size = 'md', variant = 'user' }: PartyAvatarProps,
  ref: React.ForwardedRef<any>
) => {
  const color = variantColor(variant);

  return (
    <Avatar
      ref={ref}
      name={name}
      color={color}
      size={size}
      className={className}
    />
  );
};

const forwardedPartyAvatar = React.forwardRef<any, PartyAvatarProps>(
  PartyAvatar
);
export { forwardedPartyAvatar as PartyAvatar };
